<template>
    <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="checked" :checked="value">
        <label class="form-check-label">
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: "FormCheck",
    props: {
        value: {
            required: false,
            default: false
        },
    },
    data() {
        return {
            checked: this.value
        }
    },
    watch: {
        checked: function (newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
}
</script>

<style scoped>
.form-check {
    margin-bottom: 12px;
}
</style>
